export default __webpack_public_path__ + "static/media/thum1.37c23ec1.jpg";